import React from 'react';
import styled from 'styled-components';
import desktop from '../../../assets/v2/Partner/how-to-partner-desktop.svg';
import mobile from '../../../assets/v2/Partner/how-to-partner-mobile.svg';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { SectionParent, H1, H3 } from '../../StyledComponents';

const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #f9fbfe;
  padding: 96px 0 !important;
  // max-width:800px;
`;
const SectionTitle = styled(H1)`
  padding: 0 0 20px;
  color: #1f2131;
  @media (max-width: 520px) {
    text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;

const ImgWrapperDesktop = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
  @media (max-width: 520px) {
    display: none;
  }
`;
const ImgWrapperMobile = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
  @media (min-width: 521px) {
    display: none;
  }
`;

const GridTitle = styled.div`
  height: 48px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: 2.9;
  letter-spacing: normal;
  color: #151828;
  text-align: center;

  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const StyledImgDesktop = styled(LazyLoadImage)`
  height: 110px;
`;
const StyledImgMobile = styled(LazyLoadImage)`
  height: 420px;
`;

const GridContainer = styled.div`
  display: grid;
  // grid-template-columns: repeat(3, 1fr);
  margin-top: 2rem;
  // margin-bottom: 1rem;
  // grid-gap: 6rem 10rem;
  width: 90%;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    // grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;
const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    // margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

export default () => (
  <>
    <Section>
      <SectionTitle> How to Partner with Esper </SectionTitle>
      <GridContainer style={{ maxWidth: '920px' }}>
        <ImgWrapperDesktop>
          <StyledImgDesktop src={desktop} />
        </ImgWrapperDesktop>
        <ImgWrapperMobile>
          <StyledImgMobile src={mobile} />
        </ImgWrapperMobile>
      </GridContainer>
    </Section>
  </>
);
